import React, { lazy } from 'react';

const SingleCourse = lazy(
  () => import('../OnlineTraining/DisplayCourseInfo/EachCoursePage.page.jsx')
);
const CourseHomepage = lazy(
  () => import('../TrainingRoutes/TakeCourse/CourseHomepage.page.jsx')
);
const QuizComponent = lazy(
  () => import('../TrainingRoutes/Quiz/QuizHomepage.page.jsx')
);
const CourseReview = lazy(
  () => import('../TrainingRoutes/ReviewCourse/CourseReview.page.jsx')
);
const CourseComplete = lazy(
  () =>
    import(
      '../TrainingRoutes/FinishedCourse/Completed/QuizCompletePage.page.jsx'
    )
);
const IncompleteCourse = lazy(
  () =>
    import(
      '../TrainingRoutes/FinishedCourse/Incomplete/QuizIncompletePage.page.jsx'
    )
);
const TDGCertificateHomepage = lazy(
  () =>
    import(
      '../TrainingRoutes/Certificates/TDGCertificate/TDGCertHomepage.page.jsx'
    )
);
const SectionResult = lazy(
  () => import('../TrainingRoutes/Quiz/SectionResult/SectionResult.page.jsx')
);

// Order routes from most-specific to most-generic to avoid accidental matches.
export const courseRoutes = [
  { path: ':courseId/:userCourseId/home', element: <CourseHomepage /> },
  { path: ':courseId/:userCourseId/quiz', element: <QuizComponent /> },
  { path: ':courseId/:userCourseId/complete', element: <CourseComplete /> },
  {
    path: ':courseId/:userCourseId/section-result',
    element: <SectionResult />,
  },
  { path: ':courseId/:userCourseId/tdg', element: <TDGCertificateHomepage /> },
  { path: ':courseId/:userCourseId/incomplete', element: <IncompleteCourse /> },
  { path: 'review/:id', element: <CourseReview /> },
  // Keep the generic matching route last so it doesn't override the more specific ones.
  { path: ':courseName/:id', element: <SingleCourse /> },
];
